import React from "react"
import { connect } from "react-redux"
import Dashboard from "./Dashboard"
import  * as actions from "../actions"

class DashboardContainer extends React.Component {
  componentDidUpdate = prevProps => {
     if (this.props.brand.token && !prevProps.brand.token && !this.props.recommendations) {
       this.props.getRecommendations()
     }
  }

  render() {
    return (
      <Dashboard
        {...this.state}
        {...this.props}
      />
    )
  }
}

const mapStateToProps = state => ({
  brand: state.brand,
  loaded: state.dashboard.loaded.brand && state.dashboard.loaded.recommendations,
  profiles: [],
  recommendations: state.dashboard.recommendations,
})

const mapDispatchToProps = dispatch => ({
  getRecommendations: () => dispatch(actions.getRecommendations()),
})

export default connect(mapStateToProps, mapDispatchToProps)(DashboardContainer)


// WEBPACK FOOTER //
// ./assets/dashboard/components/DemoDashboard.js